/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FcbTypeCoursGridDto
 */
export interface FcbTypeCoursGridDto {
    /**
     * 
     * @type {string}
     * @memberof FcbTypeCoursGridDto
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbTypeCoursGridDto
     */
    libelle?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FcbTypeCoursGridDto
     */
    actif?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof FcbTypeCoursGridDto
     */
    acquisIfapme?: boolean;
}

/**
 * Check if a given object implements the FcbTypeCoursGridDto interface.
 */
export function instanceOfFcbTypeCoursGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbTypeCoursGridDtoFromJSON(json: any): FcbTypeCoursGridDto {
    return FcbTypeCoursGridDtoFromJSONTyped(json, false);
}

export function FcbTypeCoursGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbTypeCoursGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'code') ? undefined : json['code'],
        'libelle': !exists(json, 'libelle') ? undefined : json['libelle'],
        'actif': !exists(json, 'actif') ? undefined : json['actif'],
        'acquisIfapme': !exists(json, 'acquisIfapme') ? undefined : json['acquisIfapme'],
    };
}

export function FcbTypeCoursGridDtoToJSON(value?: FcbTypeCoursGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'libelle': value.libelle,
        'actif': value.actif,
        'acquisIfapme': value.acquisIfapme,
    };
}

